import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { WorkerUpdateWorkerDto } from '../../_dto/_worker/WorkerUpdateWorkerDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateWorker = async (
  workerUpdateWorkerDto: WorkerUpdateWorkerDto
) => {
  const params: IApiParams = {
    url: '/worker/updateWorker.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', workerUpdateWorkerDto);
};
